import fetchData from 'utils/fetchData';

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const joinGroup = ({ groupId, code }): Promise<any> => {
  try {
    const token = localStorage.getItem('token');

    return fetchData(`${process.env._DB_HOST}api/v01/group/${groupId}/member`, {
      method: 'PUT',
      headers: { ...headers, tsec: JSON.parse(token) },
      body: JSON.stringify({ code }),
    }).then((response) => (response.ok ? {ok:true} : response.json()));
  } catch (error) {
    console.log(error);
  }
};

export const unjoinGroup = (groupId): Promise<any> => {
  try {
    const token = localStorage.getItem('token');

    return fetchData(`${process.env._DB_HOST}api/v01/group/${groupId}/member`, {
      method: 'DELETE',
      headers: { ...headers, tsec: JSON.parse(token) },
    }).then((response) => response);
  } catch (error) {
    console.log(error);
  }
};
